










import { Component, Vue } from 'vue-property-decorator';
import { ISearchResult, IFacetValue, SearchType } from '../Scripts/ISearchService';
import { IFacet } from '../Scripts/FacetDefinition';
import { FacetMetadata } from '../Scripts/FacetMetadata';
import { FilterHelper } from '../Scripts/FilterHelper';

import ActionTracker, { FacetSelectedEvent } from '../Scripts/AnalyticsEvents';

import FacetCard from './FacetCard.vue';
import FacetExplore from './FacetExplore.vue';
import FacetAcademicPeriod from './FacetAcademicPeriod.vue';

type FacetData = {
	metadata: FacetMetadata;
	data: IFacetValue[];
};

@Component({
	components: {
		FacetCard, FacetExplore, FacetAcademicPeriod
	}
})
export default class FacetPanel extends Vue {
	private modalTitle = '';

	get title (): string {
		return this.modalTitle;
	}

	get results (): ISearchResult {
		return this.$store.state.result as ISearchResult;
	}

	get showTerms (): boolean {
		return this.resultType === SearchType.Course;
	}

	get resultType (): SearchType {
		return this.$store.state.searchType;
	}

	get facetData (): FacetData[] {
		return FacetMetadata.list(this.resultType).map((m) => {
			return {
				metadata: m,
				data: this.results.facets[m.column]
			};
		});
	}

	public selection (facet: IFacetValue): void {
		const column = this.$store.state.currentFacet;

		const meta: IFacet | undefined = FacetMetadata.list(this.resultType).find((m) => m.column === column);

		if (meta) {
			const helper = new FilterHelper(this.$router);
			ActionTracker.track(new FacetSelectedEvent(meta.query, facet.value));

			helper.setFilter(meta.query, facet.value);
		}

		this.$bvModal.hide('facet-explore');
	}

	public async explore (column: string, title: string): Promise<void> {
		this.$store.commit('resetCurrentFacet');

		this.modalTitle = title;
		this.$bvModal.show('facet-explore');

		await this.$store.dispatch('performFacet', column);
	}
}
